/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, kg: NonNullable<unknown> }} My_Weighings_Total_FreshInputs */

const vi_my_weighings_total_fresh = /** @type {(inputs: My_Weighings_Total_FreshInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng ${i?.count} phiếu · ${i?.kg} kg tươi`)
};

/**

* @param {My_Weighings_Total_FreshInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_total_fresh = /** @type {((inputs: My_Weighings_Total_FreshInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_Total_FreshInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_total_fresh(inputs)
});